import React from 'react';

const StickyBottomBar = () => (
  <div
    className="fixed bottom-0 left-0 right-0 z-[150] h-[52px] border-t border-white/10 shadow-[0_-4px_20px_rgba(0,0,0,0.15)]"
    style={{ background: 'var(--atithi-hero-navy)' }}
  >
    <div className="max-w-7xl mx-auto h-full px-4 sm:px-6 flex items-center justify-center">
      <p className="text-white text-[13px] sm:text-[14px] font-medium font-body text-center">
        📞 BOOK NOW — WHATSAPP TODAY!
      </p>
    </div>
  </div>
);

export default StickyBottomBar;
